import shareds from "@/assets/js/shared";
const shared = new shareds();
import Parameters from '@/assets/js/parameters'
const parameters = new Parameters();
class Species {
    constructor(apiService = null) {
        this.obj_name = 'species';
        this.apiService = apiService; // 將 ApiService 實例儲存為屬性
    }

    // 共用的 API 呼叫方法
    async callApi(method, endpoint, parameter = {}, progressEvent = null) {
        const apiConfig = {
            url: `${this.apiService.url}${this.obj_name}/${endpoint}`,
            parameter,
        };

        return new Promise((resolve) => {
            if (method === 'get') {
                apiConfig.url += `?${this.apiService.getMethodEncryp(parameter)}`;
                this.apiService.getApi({
                    url: apiConfig.url,
                    success: resolve,
                    error: (res) => {
                        this.apiService.debug('error:', res);
                        resolve(res);
                    },
                });
            } else if (method === 'post') {
                this.apiService.postFormDataApi({
                    url: apiConfig.url,
                    parameter: apiConfig.parameter,
                    success: resolve,
                    progress: (res) => {
                        this.apiService.debug(res);
                        if (progressEvent) {
                            progressEvent(res);
                        }
                    },
                    error: (res) => {
                        this.apiService.debug('error:', res);
                        resolve(res);
                    },
                });
            } else if (method === 'delete') {
                this.apiService.delApi({
                    url: apiConfig.url,
                    parameter: apiConfig.parameter,
                    success: resolve,
                    error: (res) => {
                        this.apiService.debug('error:', res);
                        resolve(res);
                    },
                });
            }
        });
    }

    // 檢查物種類別輸入格式
    checkSpeciesModel(formData) {
        if (!formData.code || !formData.name) {
            return { status: false, message: '物種分類代碼與物種分類不能是空的' };
        }

        if (!shared.isEnglishOnly(formData.code)) {
            return { status: false, message: '物種代碼只能允許半型英文，請檢查輸入的格式。' };
        }

        return { status: true };
    }

    // 檢查物種輸入格式
    checkSpecieModel(formData) {
        if (!formData.name) {
            return { status: false, message: '物種名稱不能是空的' };
        }

        return { status: true };
    }

    getTestParameterFrom(){
        let list = []
        const examSetting = parameters.examSetting
        for (let i = 0; i < examSetting.length; i++) {
            const el = examSetting[i];
            console.log(`el=`,el)
            if ( el.item != null ){

                const examType = parameters.inSide_list.find(item=>item.id == el.exam_type)
                
                if ( examType ){
                    let device = null
                    if ( el.exam_device_id != null ){
                        const findDevice = parameters.device_list.find(item=>item.id == el.exam_device_id)
                        device = findDevice ? findDevice : null
                    }
                    
                    //建立空表單
                    let examItem = []
                    for (let n = 0; n < el.item.length; n++) {
                        const item = el.item[n];
                        examItem.push({
                            name: item.name,
                            unit: item.unit,
                            min: 0,
                            max: 0
                        })
                    }

                    list.push({
                        exam_type: el.exam_type,
                        exam_type_name: examType.name,
                        exam_device_id: el.exam_device_id,
                        exam_device_name: device ? device.name : null,
                        item: examItem
                    })
                }
            }
        }
        return list
    }

    // API 方法
    //物種管理 | 101新增物種類別
    async addSpeciesCategory(parameter, progressEvent = null) {
        return this.callApi('post', 'addSpeciesCategory', parameter, progressEvent);
    }
    //物種管理 | 102更新物種類別
    async updSpeciesCategory(parameter, progressEvent = null) {
        return this.callApi('post', 'updSpeciesCategory', parameter, progressEvent);
    }
    //物種管理 | 103刪除物種類別
    async delSpeciesCategory(parameter) {
        return this.callApi('delete', 'delSpeciesCategory', parameter);
    }
    //物種管理 | 104搜尋物種類別
    async getSpeciesCategoryByName(parameter = null) {
        return this.callApi('get', 'getSpeciesCategoryByName', parameter);
    }
    //物種管理 | 105新增物種
    async addSpecies(parameter, progressEvent = null) {
        return this.callApi('post', 'addSpecies', parameter, progressEvent);
    }
    //物種管理 | 106更新物種
    async updSpecies(parameter, progressEvent = null) {
        return this.callApi('post', 'updSpecies', parameter, progressEvent);
    }
    //物種管理 | 107刪除物種
    async delSpecies(parameter) {
        return this.callApi('delete', 'delSpecies', parameter);
    }
    //物種管理 | 108搜尋物種
    async getSpeciesByNameAndSpeciesCategoryId(parameter = null) {
        return this.callApi('get', 'getSpeciesByNameAndSpeciesCategoryId', parameter);
    }
    //物種管理 | 109取得物種詳細資料
    async getSpecies(parameter = null) {
        return this.callApi('get', 'getSpecies', parameter);
    }
}

export default Species;
